import { TagColors } from '@navi/web-ui/lib/primitives/Tag/types';
import React from 'react';

export enum TabsKey {
  OPEN_ANOMALY = 'open',
  CLOSED_ANOMALY = 'closed'
}

export enum AnomalyType {
  AGENT = 'AGENT',
  AGENCY = 'AGENCY'
}

export enum AnomalyPriorityColor {
  P0 = 'red',
  P1 = 'orange',
  P2 = 'yellow'
}

export enum AnomalyActionTabsKey {
  RCA = 'rca',
  ETA = 'eta',
  RESOLVE_ANOMALY = 'resolve_anomaly'
}

export enum AnomalyTableKeys {
  OPEN_ANOMALY_TABLE = 'openAnomalyTable',
  CLOSED_ANOMALY_TABLE = 'closedAnomalyTable',
  ANOMALY_TABLE_ACTION = 'anomalyTableAction'
}

export enum AnomalyStatus {
  OPEN = 'open',
  CLOSED = 'closed'
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface IAnomalyData {
  anomalyId: string;
  anomalyReferenceId: string;
  anomalyDetectedOn: AnomalyType;
  anomalyStatus: AnomalyStatus;
  anomalyPriority: string;
  anomalyDescription: string;
  assignedTo: string;
  isAssignedToYou: boolean;
  createdDate: string;
  updatedDate: string;
  createdAt: string;
  raisedFor: {
    name: string;
    id: string;
    agencyCode: string;
    allocations: number;
  };
  estimatedTime: {
    at: string;
    by: string;
    status?: string;
  };
  rca?: {
    at: string;
    by: string;
  };
}

export interface IDaysTillEscalation {
  daysTillEscalation: number;
  progressPercent: number;
  progressTextClass?: string;
  containerClass?: string;
  sqSize?: number;
  strokeWidth?: number;
}

export interface ITableRaisedFor {
  info: IAnomalyData;
}

export interface ITableActions {
  viewAnomalyHandler: (anomalyData: IAnomalyData) => void;
  info: IAnomalyData;
}

export enum AnomalyStatusType {
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED'
}

export interface IEstimatesDetails {
  descriptionClass?: string;
}

export interface IEtaDefaultValues {
  at: string;
  reason: string;
}

export interface IRcaDefaultValues {
  reason: string;
  comment: string;
}

export interface IResolveAnomalyDefaultValues {
  comment: string;
}

export enum ValidationMessage {
  NO_ONLY_SPECIAL_CHARS = 'Only special characters not allowed',
  NO_ONLY_NUMBERS = 'Only numbers not allowed',
  NO_NUMBERS_AND_SPECIAL_CHARS = 'Text cannot contain only numbers and special characters'
}

export interface IAnomalySubmitCta {
  disabled: boolean;
  onSubmit: (e?: React.BaseSyntheticEvent<object, any, any | undefined>) => Promise<void>;
}

export interface IResolveAnomalyPopup {
  toggleConfirmationPopup: () => void;
  onSubmit: (e?: React.BaseSyntheticEvent<object, any, any | undefined>) => Promise<void>;
}

export interface IUpdateAnomalyPayload {
  resolution?: IResolveAnomalyDefaultValues;
  eta?: IEtaDefaultValues;
  rca?: IRcaDefaultValues;
}

export interface IKeyValue {
  title: string;
  description: string | React.ReactNode | null;
  rightIcon?: React.ReactNode;
  containerClass?: string;
}

export interface IOption {
  label: string;
  value: string;
}

export const UserActivityStatusMap = {
  RCA_FILLED: { color: 'green', label: 'RCA filled' },
  INTACT: { color: 'violet', label: 'ETA' },
  BREACHED: { color: 'red', label: 'ETA' }
} as {
  [key: string]: {
    color: TagColors;
    label: string;
  };
};

export enum ActivityLogsType {
  RCA = 'RCA',
  ETA = 'ETA'
}

export interface IActivityLogs {
  type: ActivityLogsType;
  details: {
    name: string;
    at: string;
    by: string;
    reason: string;
    comment: string;
  };
}
